import styled from 'styled-components';
import _omit from 'lodash/omit';
import { buttonColors } from 'components/Button/styles';
import {
  AMBER,
  AZURE,
  BLACK,
  BLUE_VIOLET,
  EUCALYPTUS,
  GALLERY,
  PUNCH,
  STEEL_BLUE,
  CRUSTA,
} from 'constants/colors';

export const textColors = _omit(buttonColors, ['ghost']);

// colors
export const colorTypes = {
  [textColors.default]: STEEL_BLUE,
  [textColors.primary]: BLUE_VIOLET,
  [textColors.secondary]: CRUSTA,
  [textColors.danger]: PUNCH,
  [textColors.success]: EUCALYPTUS,
  [textColors.info]: AZURE,
  [textColors.warning]: AMBER,
  [textColors.dark]: BLACK,
  [textColors.light]: GALLERY,
};

export const TextColoredWrap = styled.div`
  display: inline;
  > * {
    color: ${({ color }) => (color ? (colorTypes[color] || color) : 'inherit')};
  }
  padding: ${({ padding }) => padding || '0'};
`;